import {
  TapOptimizePathName,
  TapOptimizeRoute,
} from '@/modules/ta/tapoptimize/tapoptimize.constants';
import { TapOptimizeRouteConfig } from '@/modules/ta/tapoptimize/TapOptimizeRouteConfig';
import { Module } from '@/modules/core/app/constants/app.constants';

export const router = TapOptimizeRouteConfig.factory(
  [
    {
      path: `/${TapOptimizeRoute.TAP_OPTIMIZE}`,
      name: TapOptimizePathName.TAP_OPTIMIZE,
      component: () =>
        import(/* webpackChunkName: "tapoptimize-page" */ './pages/TapOptimizePage.vue'),
    },
    {
      path: `/${TapOptimizeRoute.TAP_OPTIMIZE}/new`,
      name: TapOptimizePathName.TAP_OPTIMIZE_FORM_NEW,
      component: () =>
        import(/* webpackChunkName: "tapoptimizeform-page" */ './pages/TapOptimizeFormPage.vue'),
    },
    {
      path: `/${TapOptimizeRoute.TAP_OPTIMIZE}/view/:id`,
      name: TapOptimizePathName.TAP_OPTIMIZE_DASHBOARD,
      component: () =>
        import(
          /* webpackChunkName: "tapoptimizedashboard-page" */ './pages/TapOptimizeDashboardPage.vue'
        ),
    },
    {
      path: `/${TapOptimizeRoute.TAP_OPTIMIZE}/edit/:id`,
      name: TapOptimizePathName.TAP_OPTIMIZE_FORM,
      component: () =>
        import(/* webpackChunkName: "tapoptimizeform-page" */ './pages/TapOptimizeFormPage.vue'),
    },
  ],
  Module.TAP_OPTIMIZE
);
